// The four print styles, as main defines them in @app/common (apps/common/src/product/EPrintStyle.ts).
// This branch's @app/common is still an empty CommonJS skeleton that exports nothing, so the
// back-office mock-ups read the enum from here; the values are the same, and a merge of main
// can point these imports back at the shared package.
enum EPrintStyle {
    BICOLOR = 'BICOLOR',
    MONOCOLOR = 'MONOCOLOR',
    QUADRI_LARGE_HEIGHT = 'QUADRI_LARGE_HEIGHT',
    QUADRI_SMALL_HEIGHT = 'QUADRI_SMALL_HEIGHT',
}

export { EPrintStyle };
